import { FC, memo } from 'react'
import { Box, Tooltip } from '@chakra-ui/react'

type Props = {
  children?: JSX.Element
}

const FeatureNotYetAvailable: FC<Props> = ({ children }) => {
  return (
    <Tooltip label="Esta funcionalidade ainda não está disponível">
      <Box opacity={0.5} cursor="not-allowed" onClick={(event) => event.preventDefault()}>
        {children}
      </Box>
    </Tooltip>
  )
}

export default memo(FeatureNotYetAvailable)
